import React from 'react';
import PropTypes from 'prop-types';
import ModalApiConfirmationImage from '../ModalApiConfirmationImage';
import MarkFileUploaded from '../../../../common/components/MarkFileUploaded';
import FieldPasteFile from '../../../../common/components/FieldPasteFile';
import example from 'common/assets/mock/files_small/file_small_1.jpg';
import iconOpenInBrowser from 'common/assets/open_in_browser-24px.svg';
import styles from './styles.module.scss';

const AutoAcceptInteract = ({
                              separateTabLink = 'about:blank',
                              fieldId,
                              fileUploaded,
                              onFileSelected,
                              showModalApiButton = true,
                              showLinkButton = true,
                              setFieldValue
                            }) => {

  return (
    <div className={styles.autoAcceptInteract}>
      {showModalApiButton &&
        <ModalApiConfirmationImage
          img={example}
          buttonLabel={'הפק'}
        />
      }
      {showModalApiButton && <div className={styles.divideLine}/>}
      {showLinkButton &&
        <a
          href={separateTabLink}
          className={styles.openSeparateTabButton}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={iconOpenInBrowser}
            className={styles.iconOpenInBrowser}
            alt="iconOpenInBrowser"
          />
          <div>{'אתר'}</div>
        </a>
      }
      <div className={styles.addFileButton}>
        <FieldPasteFile
          fieldId={fieldId}
          fileUploaded={fileUploaded}
          onFileSelected={onFileSelected}
          setFieldValue={setFieldValue}
        />
        {(fileUploaded) && <MarkFileUploaded/>}
      </div>
    </div>
  );
};

AutoAcceptInteract.propTypes = {
  fieldId: PropTypes.string,
  showModalApiButton: PropTypes.bool,
  showLinkButton: PropTypes.bool,
};

export default AutoAcceptInteract;
